<template>
  <div class="Judge answerarea-item fontsize-16" :id="questionitem.innerid">
    <div class="topic-types">
        <p class="name" v-if="!isMaterialsItem"><span>{{questionitem.questionindex}}.</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="name" v-else><span>{{questioninfo.questionindex}}.{{questionitem.questionindex}}</span>{{questionitem.questiontypename}}，本题{{questionitem.quesscore}}分</p>
        <p class="title" v-html="questionitem.subject"></p>
        
        <div class="option-list">
          
            <div class="option-item">
                <template v-if="examstatus == 1 || isshow == 1">
                  <!-- {{questionitem.uselanswer == questionitem.finalanswer}} -->
                  <i class="el-icon-check" v-if="questionitem.uselanswer == questionitem.finalanswer && questionitem.finalanswer == 'T'"></i>
                  <i class="el-icon-close" v-else-if="questionitem.finalanswer == 'F' && questionitem.uselanswer == 'T'"></i>
                  <i class="el-icon-view" style="visibility:hidden" v-else></i>
                </template>
                <template v-else>
                  <i class="el-icon-view" style="visibility:hidden"></i>
                  <!-- end 占位用图标 -->
                </template>
                <el-radio label="T" v-model="questionitem.uselanswer" :disabled="examstatus == 1">
                  <span class="option-text">正确</span>
                </el-radio>
            </div>

            <div class="option-item">

                <template v-if="examstatus == 1 || isshow == 1">
                  <i class="el-icon-check" v-if="questionitem.finalanswer == 'F' && questionitem.finalanswer == questionitem.uselanswer"></i>
                  <i class="el-icon-close" v-else-if="questionitem.finalanswer == 'T' && questionitem.uselanswer == 'F'"></i>
                  <i class="el-icon-view" style="visibility:hidden" v-else></i>
                </template>

                <template v-else>
                  <i class="el-icon-view" style="visibility:hidden"></i>
                  <!-- end 占位用图标 -->
                </template>
                <el-radio label="F" v-model="questionitem.uselanswer" :disabled="examstatus == 1">
                  <span class="option-text">错误</span>
                </el-radio>
            </div>

        </div>
      </div>
      <div class="topic-types answer" v-if="examstatus == 1 || isshow == 1">
        <p>
          <span>本题得分：</span>
          <span class="fraction">{{questionitem.userscore}}分</span>
        </p>
        <p>
          <span>正确答案：</span>
          <span>{{questionitem.finalanswer == "T"?'正确':'错误'}}</span>
        </p>
        <p>
          <span>答案解析：</span>
          <span v-html="questionitem.quesanalysis"></span>
        </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Judge',
  props: ['questionitem', 'examstatus', 'isshow', 'isMaterialsItem', 'questioninfo'], // 试题列表  试卷提交状态 是否显示正确答案
  data () {
    return {}
  },
  mounted () {
    // 填写过答案情况下
    // this.$nextTick(() => {
    //   if (this.questionitem.finalanswer) {
    //     this.questionitem.uselanswer =  this.questionitem.finalanswer
    //   }
    // })
  },
  methods: {},
  filters: {},
  watch: {
    questionitems: {
      handler() {
        // 填写过答案情况下
        if (this.questionitem.finalanswer) {
          // this.questionitem.uselanswer =  this.questionitem.finalanswer
          // console.log(this.questionitem.uselanswer)
          // console.log(this.questionitem.finalanswer)
        }
      }
    }
  },
  computed: {
    questionitems() {
      return this.questionitem
    }
  },
  components: {}
}
</script>

<style lang="scss" type="text/scss" scope>
.Judge {

}
</style>